import json from './sprite.js';

export default {
    handle: 'ENG_SPS6-HitByBall',
    label: 'en_SPS6-HitByBall_225002289',
    json,
};
